var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoFavoriteDataProperties(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 135,
    viewBox: "0 0 172 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.1861,
    cy: 19.1695,
    r: 4.45739,
    fill: "#403B37",
    stroke: "#403B37",
    strokeWidth: 6.5375
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.814,
    cy: 19.1695,
    r: 4.45739,
    fill: "#403B37",
    stroke: "#403B37",
    strokeWidth: 6.5375
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3848 123.018C14.3848 123.018 36.7164 93.8965 83.69 93.8965C130.664 93.8965 157.616 123.018 157.616 123.018",
    stroke: "#403B37",
    strokeWidth: 6.5375,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFavoriteDataProperties);
export default __webpack_public_path__ + "static/media/no_favorite_data_properties.18c47d82b9c20101341afe75eaf906e5.svg";
export { ForwardRef as ReactComponent };